import { CustomToggleButtonGroup } from '@/ui/components/CustomToggleButtonGroup'
import { useDispatch, useSelector } from 'react-redux'
import { selectDisplayValueMode } from '@/data/replenishmentPlan/slice/replenishmentPlan.selectors.ts'
import { DisplayValueMode } from '@/data/replenishmentPlan/slice/replenishmentPlan.types.ts'
import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { replenishmentPlanActions } from '@/data/replenishmentPlan/slice/replenishmentPlan.slice.ts'
import { DatagridViewEvent } from '@/core/analytics/events/replenishmentPlan/DatagridViewEvent'
import { useTrackReplenishmentPlanAnalyticsEvent } from '@/core/hooks/useTrackReplenishmentPlanAnalyticsEvent.ts'

const DisplayValueModeToggle = () => {
  const { trackReplenishmentPlanAnalyticsEvent } =
    useTrackReplenishmentPlanAnalyticsEvent()

  const displayValueMode = useSelector(selectDisplayValueMode)

  const dispatch = useDispatch()

  useEffect(() => {
    trackReplenishmentPlanAnalyticsEvent(
      new DatagridViewEvent({
        units:
          displayValueMode === DisplayValueMode.cost ? 'money' : 'quantity',
      }),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackReplenishmentPlanAnalyticsEvent])

  const onChange = (displayValueMode: DisplayValueMode) => {
    trackReplenishmentPlanAnalyticsEvent(
      new DatagridViewEvent({
        units:
          displayValueMode === DisplayValueMode.cost ? 'money' : 'quantity',
      }),
    )

    dispatch(replenishmentPlanActions.setDisplayValueMode(displayValueMode))
  }

  const { t } = useTranslation()

  const displayValueModeToText: Record<DisplayValueMode, string> = useMemo(
    () => ({
      [DisplayValueMode.cost]: t('displayValueModeToggle.cost'),
      [DisplayValueMode.amount]: t('displayValueModeToggle.amount'),
    }),
    [t],
  )

  const displayValueModeToTooltip: Record<DisplayValueMode, string> = useMemo(
    () => ({
      [DisplayValueMode.cost]: t('displayValueModeToggle.costTooltip'),
      [DisplayValueMode.amount]: t('displayValueModeToggle.amountTooltip'),
    }),
    [t],
  )

  return (
    <CustomToggleButtonGroup
      optionToString={(option) => displayValueModeToText[option]}
      options={[DisplayValueMode.cost, DisplayValueMode.amount]}
      value={displayValueMode}
      getTooltipText={(option) => displayValueModeToTooltip[option]}
      onChange={onChange}
    />
  )
}

export default DisplayValueModeToggle
